import { createContext } from 'react'

export const EndowmentContext = createContext()
